import { Box } from "@mui/material";
import styled from "styled-components";

export const HomePageWrapper = styled(Box)`
font-family: 'Noto Sans', sans-serif;
.bannerContent {
    height: 100%;
}

.homeloader {
    display: flex;
    justify-content: center;
    align-items: center;
    z-Index: 1300;

    .loader {
        width: 100%;

        h6 {
            font-family: 'Noto Sans', sans-serif;
        }
    }
}

.homePageContainer {
    .tableHeaderRight.d-flex {
        justify-content: space-between;

        .buttonBox {
            display: flex;
            gap: 10px;

        }

        h4 {
            font-size: 20px;
            color: #1B4A83;
            font-weight: 600;
            font-family: 'Noto Sans', sans-serif;
        }

        .btnCreate {
            m: 1;
            position: relative;
        }

        button {
            background-color: rgb(3, 113, 91);
            text-transform: capitalize;
            font-family: 'Noto Sans', sans-serif;
        }

        .compareButton {
            background-color: #1b4a83;

        }
    }

    .tableSearchHeader {
        margin-top: 10px;

        .d-flex {
            justify-content: space-between;
            align-items: center;
            font-family: 'Noto Sans', sans-serif;

            .searchInput {
                width: 400px;
                background-color: #fff;

                .css-wb57ya-MuiFormControl-root-MuiTextField-root {
                    display: flex;
                }

                .searchTextBox {
                    width: 100%;
                }
            }

            .tableHeaderLeft {
                display: flex;
                justify-content: flex-end;
                align-items: center;
                width: 70%;

                h5 {
                    font-weight: 600;
                    color: #000000;
                    font-size: 14px;
                    margin-right: 5px;
                    font-family: 'Noto Sans', sans-serif;

                    span {
                        font-weight: 500;

                        &:after {
                            content: "|";
                            font-weight: 600;
                            padding: 20px;
                            color: #1B4A83;
                        }
                    }
                }

                .customDropdown {
                    width: 26%;
                    background-color: white;

                    .css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.MuiSelect-select {
                        height: 0.4375rem;
                        min-height: auto;
                        font-family: 'Noto Sans', sans-serif;
                    }

                    .css-1yk1gt9-MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root {
                        line-height: 0.5;
                        font-family: 'Noto Sans', sans-serif;
                    }
                }

            }
        }
    }

    .tableSection {
        margin-top: 20px;
        margin-bottom: 50px;
    }

    .fixedcolumnHeaderone {
        position: sticky;
        left: 0;
        zIndex: 0 !important;
        background: #1B4A83;
        font-family: 'Noto Sans', sans-serif;
        max-width: 100px;
        min-width: 100px;
        word-break: break-word;
        text-wrap: balance;
        z-Index:2;
    }

    .fixedcolumnHeadertwo {
        position: sticky;
        left: 100px;
        background: #1B4A83;
        font-family: 'Noto Sans', sans-serif;
        max-width:  100px;
        min-width:  100px;
        word-break: break-word;
        text-wrap: balance;
        z-Index:2;
    }

    .dragColumnHeader {
       background: #1B4A83;
        font-family: 'Noto Sans', sans-serif;
        max-width:  100px;
        min-width:  100px;
        word-break: break-word;
        text-wrap: balance;
        z-Index:0;
    }

    .fixedColumnone {
        white-space: nowrap;
        position: sticky;
        left: 0;
        padding:6px 11px;
        background: white;
        font-family: 'Noto Sans', sans-serif;
        max-width: 100px;
        min-width: 100px;
        word-break: break-word;
        text-wrap: balance;
        z-Index:1;
    }

    .fixedColumntwo {
        white-space: nowrap;
        position: sticky;
        left: 100px;
        padding:6px 11px;
        background: white;
        font-family: 'Noto Sans', sans-serif;
        max-width:  100px;
        min-width:  100px;
        word-break: break-word;
        text-wrap: balance;
        z-Index:1;
    }

    .dragColumn {
        font-family: 'Noto Sans', sans-serif;
        max-width:  100px;
        min-width:  100px;
        word-break: break-word;
        text-wrap: balance;
        z-Index:0;
    }

    .btnMyRequest:hover, .btnMyRequest-active{
        color: rgb(27, 74, 131) !important;    
        text-decoration: underline;
        border-color: rgb(27, 74, 131) !important;
        border-radius: 3px;
  }
    .myRequestContainer:hover{
        border-color: rgb(27, 74, 131) !important;
        border-radius: 3px;
  }
 
}

`;

export const ActionBoxWrapper = styled(Box)`
color: #1B4A83;
svg{
    margin: 0 10px 0 0;
    font-size: 20px;
}
.icon
{
    padding: 0px;
     color: #1B4A83;
}
`;


